/**
 * @generated SignedSource<<04e65282b2d7bd6ecc23443845cb3949>>
 * @relayHash a47e1cbd9d1f89df945d0b54740a5a2b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5a921844bce3f100ea5912f8d38189a75b0ec84d8fc6d7497d40178c784f86b4

import type { ConcreteRequest } from 'relay-runtime';
export type LoomPermissionQuery$variables = {
  permissionId: string;
  resourceId: string;
};
export type LoomPermissionQuery$data = {
  readonly permitted: boolean | null;
};
export type LoomPermissionQuery = {
  response: LoomPermissionQuery$data;
  variables: LoomPermissionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "permissionId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "resourceId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "permissionId",
        "variableName": "permissionId"
      },
      {
        "kind": "Variable",
        "name": "resourceId",
        "variableName": "resourceId"
      }
    ],
    "kind": "ScalarField",
    "name": "permitted"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LoomPermissionQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LoomPermissionQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "5a921844bce3f100ea5912f8d38189a75b0ec84d8fc6d7497d40178c784f86b4",
    "metadata": {},
    "name": "LoomPermissionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5025da211da016dbec919be200319dea";

export default node;
